import { Gavel, Clock, Ban, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export const TIMEOUT_OPTIONS = [
  { minutes: 10, label: "10 minutes" },
  { minutes: 60, label: "1 hour" },
  { minutes: 1440, label: "24 hours" },
  { minutes: 10080, label: "7 days" },
];

const errMsg = (e, fallback) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export async function timeoutUser(userId, minutes, name) {
  try {
    const { data } = await api.post(`/admin/users/${userId}/timeout`, { minutes });
    toast.success(minutes ? `${name} timed out for ${TIMEOUT_OPTIONS.find((o) => o.minutes === minutes)?.label || `${minutes} min`}.` : `${name}'s timeout cleared.`);
    return data;
  } catch (e) {
    toast.error(errMsg(e, "Could not time out user"));
    return null;
  }
}

export async function banUser(userId, banned, name) {
  if (banned && !window.confirm(`Ban ${name} from Tavern Chat? Their messages will be removed.`)) return null;
  try {
    const { data } = await api.post(`/admin/users/${userId}/ban`, { banned, delete_messages: true });
    toast.success(banned ? `${name} banned. ${data.messages_deleted} message(s) removed.` : `${name} unbanned.`);
    return data;
  } catch (e) {
    toast.error(errMsg(e, "Could not update ban"));
    return null;
  }
}

export function MessageModMenu({ message, onDelete, onBanned }) {
  const canModerate = message.role !== "admin";
  const name = message.author_name;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="self-center text-zinc-600 hover:text-crimson-bright p-1" data-testid={`mod-menu-${message.message_id}`} title="Moderate">
          <Gavel size={14} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-zinc-950 border-zinc-800 text-zinc-200 min-w-[180px]">
        {canModerate && (
          <>
            <DropdownMenuLabel className="text-[10px] tracking-[0.3em] uppercase text-zinc-500">Timeout {name}</DropdownMenuLabel>
            {TIMEOUT_OPTIONS.map((o) => (
              <DropdownMenuItem key={o.minutes} onClick={() => timeoutUser(message.user_id, o.minutes, name)}
                data-testid={`mod-timeout-${o.minutes}-${message.message_id}`} className="cursor-pointer gap-2">
                <Clock size={13} /> {o.label}
              </DropdownMenuItem>
            ))}
            <DropdownMenuSeparator className="bg-zinc-800" />
            <DropdownMenuItem onClick={async () => { if (await banUser(message.user_id, true, name)) onBanned(message.user_id); }}
              data-testid={`mod-ban-${message.message_id}`} className="cursor-pointer gap-2 text-crimson-bright focus:text-crimson-bright">
              <Ban size={13} /> Ban from chat
            </DropdownMenuItem>
            <DropdownMenuSeparator className="bg-zinc-800" />
          </>
        )}
        <DropdownMenuItem onClick={() => onDelete(message)} data-testid={`delete-message-${message.message_id}`} className="cursor-pointer gap-2">
          <Trash2 size={13} /> Delete message
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
